import {Utils} from '@exp1/front-utils'
import {locationApi} from 'api'
import {Params, Responses} from 'commonTypes/locations'

export const locationsHooks = new Utils.CrudHooks<
  never,
  Params.Update,
  Responses.List,
  Responses.Item,
  never,
  Responses.Update
>('location', 'Location', locationApi)
